import _ from 'underscore';

export const processError = ({ errors, scope, i18n }) => {
  let errorMsg = i18n.getString('HotelCenter_Overview_Bulk_Errormsg_GenericMsg');

  const result = _.pluck(errors, 'Code')[0];

  const errorMsgMap = {
    EntityDoesNotExist: i18n.getString('HotelCenter_Overview_Bulk_Errormsg_EntityDoesNotExist').replace(/\{0\}/g, scope),
    DefaultHotelGroupUpdateNotAllowed: i18n.getString('HotelCenter_Overview_Bulk_Errormsg_DefaultHotelGroupUpdateNotAllowed'),
    DuplicateValues: i18n.getString('HotelCenter_Overview_Bulk_Errormsg_DuplicateValues'),
    InvalidValue: i18n.getString(_TL_('Invalid value')),
    InvalidBidMultiplier: i18n.getString(_TL_('Invalid bid multiplier value')),
    SwitchingofBidTypeFromPPStoNonPPSAndViceVersaIsNotAllowed: i18n.getString(_TL_('Switching of bid type from PPS to non-PPS and vice versa is not allowed')),
    OnlySupportedBMValueIsDecreaseby100OrIncreaseby0: i18n.getString(_TL_('Only supported BM value is decrease by 100 or increase by 0')),
  };

  if (_.has(errorMsgMap, result)) {
    errorMsg = errorMsgMap[result];
  }

  return errorMsg;
};
